import { useQuery } from '@tanstack/react-query';

import apiHelper from '@/apiHelper';
import { NookResponse } from '@/types/nook';

export function useFetchNookQuery(nookId: string) {
  return useQuery({
    queryKey: ['nook', nookId, 'content'],
    queryFn: async (): Promise<NookResponse> => {
      const response = await apiHelper.get(`/api/nook/${nookId}`);
      return response.data?.data;
    },
    // Don't auto-fetch - we'll trigger this manually when updates are detected
    enabled: false,
  });
}

export default useFetchNookQuery;
